<div class="box">
  <div class="box-row header">
    <app-header-bar [backRoute]="'/information'" [autoTranslateTitle]="false" [title]="contentItem?.name || ''"></app-header-bar>
  </div>
  @if (contentItem?.type === ContentType.PAGE && contentItem?.parent?.id) {
    <a [routerLink]="['/information', contentItem?.parent?.id]" class="ps-0 btn btn-link d-flex flex-row align-items-center">
      <mat-icon class="mat-icon-rtl-mirror">turn_left</mat-icon>
      <h5 class="mb-0">{{'contents.moveUp' | translate}}</h5>
    </a>
  } @else if(contentItem?.type === ContentType.PAGE) {
    <a [routerLink]="['/information']" class="ps-0 btn btn-link d-flex flex-row align-items-center">
      <mat-icon class="mat-icon-rtl-mirror">turn_left</mat-icon>
      <h5 class="mb-0">{{'contents.moveUp' | translate}}</h5>
    </a>
  }
  @switch (contentItem?.type) {
    @case (ContentType.PAGE) {
      <div class="p-3 bg-white" [id]="'content-container-' + contentItem?.id">
        @switch (contentItem?.pageType) {
          @case (PageType.WYSIWYG) {
            <div [innerHTML]="cleanedContent || ''"></div>
          }
          @case (PageType.HTML) {
            <div [innerHTML]="cleanedContent"></div>
          }
        }
      </div>
    }
    @case (ContentType.FOLDER) {
      @if (contentItem?.content) {
        <div>{{contentItem!.content}}</div>
      }
      @if (contentItem?.children && contentItem!.children!.length) {
        <app-information-folder [parent]="contentItem"></app-information-folder>
      } @else {
        <h4>{{ 'contents.noChildren' | translate }}</h4>
      }
    }
  }

  <app-error [error]="error"></app-error>
</div>
